import React from 'react';
import {DataGrid, Column} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {GroupItem, SimpleItem, Label} from "devextreme-react/form";
import IPaieTauxCcq from "../../models/IPaieTauxCcq";
import {FormListBase, FormListBaseTab, FormListBaseGrid} from '../base';
import {} from 'devextreme-react';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

export default function TauxCCQ() {
    const paieTauxFormDataSource = useCustomDataSource<IPaieTauxCcq, IPaieTauxCcq>({path: "paieTauxCcq", primaryKey: "idPaieTauxCcq"});
    const {selectedDataRow: selectedPaieTauxCcq, mode, setMode, isFieldModifier, setIsFieldModifier} = paieTauxFormDataSource;

    return (
        <FormListBase data={paieTauxFormDataSource}>
            <FormListBaseGrid dataSource={paieTauxFormDataSource.dataSource}>
                <Column key={"grid-col-idMetier"} dataField={"idMetier"} caption="Métier" allowHiding={false}/>
                <Column key={"grid-col-idMetierSecteur"} dataField={"idMetierSecteur"} caption="Secteur" allowHiding={false}/>
                <Column key={"grid-col-idMetierCompetence"} dataField={"idMetierCompetence"} caption="Compétence" allowHiding={false}/>
            </FormListBaseGrid>
            <FormListBaseTab>
                <TabItem title="Informations">
                    <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedPaieTauxCcq || {} as IPaieTauxCcq} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                        <GroupItem colCount={3} alignItemLabels={false}>
                            <GroupItem>
                                <GroupItem alignItemLabels={true} caption={"Métier"}>
                                    <SimpleItem key={"frm-idMetier"} dataField={"idMetier"}>
                                        <Label text={"Métier"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-idMetierSecteur"} dataField={"idMetierSecteur"}>
                                        <Label text={"Secteur"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-idMetierCompetence"} dataField={"idMetierCompetence"}>
                                        <Label text={"Compétence"}/>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem alignItemLabels={true} caption={"Taux horaire"}>
                                    <SimpleItem key={"frm-tauxRegulier"} dataField={"tauxRegulier"}>
                                        <Label text={"Régulier"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-tauxDemiJournee"} dataField={"tauxDemiJournee"}>
                                        <Label text={"Régulier"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-tauxTempsDouble"} dataField={"tauxTempsDouble"}>
                                        <Label text={"Double"}/>
                                    </SimpleItem>
                                </GroupItem>
                            </GroupItem>
                            <GroupItem>
                                <GroupItem alignItemLabels={true} caption={"Avantages sociaux (/heure)"}>
                                    <SimpleItem key={"frm-retraitePartSalarie"} dataField={"retraitePartSalarie"}>
                                        <Label text={"Part du salarié"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-retraitePartEmployeur"} dataField={"retraitePartEmployeur"}>
                                        <Label text={"Part de l'employeur (retraite)"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-assurancePartEmployeur"} dataField={"assurancePartEmployeur"}>
                                        <Label text={"Part de l'employeur (assurances)"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-totalPartEmployeur"} dataField={"totalPartEmployeur"}>
                                        <Label text={"Total part de l'employeur"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-totalPartSalarieEtEmployeur"} dataField={"totalPartSalarieEtEmployeur"}>
                                        <Label text={"Total part du salarié et de l'employeur"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-avantagesImposables"} dataField={"avantagesImposables"}>
                                        <Label text={"Avantages imposables"}/>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem alignItemLabels={true} caption={"Frais de participation volontaire au régime d'avantages sociaux"}>
                                    <SimpleItem key={"frm-fraisParticipationVolontaireSalarie"} dataField={"fraisParticipationVolontaireSalarie"}>
                                        <Label text={"Part du salarié (/heure)"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-fraisParticipationVolontaireEmployeur"} dataField={"fraisParticipationVolontaireEmployeur"}>
                                        <Label text={"Part de l'employeur (/heure)"}/>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem alignItemLabels={true} caption={"Prélèvement"}>
                                    <SimpleItem key={"frm-prelevementMinimum"} dataField={"prelevementMinimum"}>
                                        <Label text={"Prélèvement minimum"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-prelevementPartSalarie"} dataField={"prelevementPartSalarie"}>
                                        <Label text={"Part du salarié (% du total (salaire + congés payés))"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-prelevementPartEmployeur"} dataField={"prelevementPartEmployeur"}>
                                        <Label text={"Part de l'empl. (% du total (salaire + congés payés))"}/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem alignItemLabels={true} caption={""}>
                                    <SimpleItem key={"frm-taxeSurAssurance"} dataField={"taxeSurAssurance"}>
                                        <Label text={"Taxe sur assurance"}/>
                                    </SimpleItem>
                                </GroupItem>
                            </GroupItem>
                            <GroupItem alignItemLabels={true} caption={"Cotisations syndicales (payées par le salarié)"}>
                                <SimpleItem key={"frm-fondsQualification"} dataField={"fondsQualification"}>
                                    <Label text={"Fonds de qualification"}/>
                                </SimpleItem>
                                <SimpleItem key={"frm-fondsFormation"} dataField={"fondsFormation"}>
                                    <Label text={"Fonds de formation"}/>
                                </SimpleItem>
                                <SimpleItem key={"frm-equipementSecurite"} dataField={"equipementSecurite"}>
                                    <Label text={"Équipement de sécurité"}/>
                                </SimpleItem>
                                <SimpleItem key={"frm-contributionSectorielle"} dataField={"contributionSectorielle"}>
                                    <Label text={"Contribution sectorielle"}/>
                                </SimpleItem>

                                <GroupItem>
                                    <DataGrid showBorders={true} allowColumnResizing={true}>
                                        <Column caption={"Syndicat"} dataType={"string"}/>
                                        <Column caption={"Taux hebdomadaire"} dataType={"string"}/>
                                        <Column caption={"Taux mensuel"} dataType={"string"}/>
                                        <Column caption={"Plus autres frais"} dataType={"string"}/>
                                    </DataGrid>
                                </GroupItem>
                            </GroupItem>
                        </GroupItem>
                    </Form>
                </TabItem>
                <TabItem title="Système"><FormSysteme formData={selectedPaieTauxCcq || {} as IPaieTauxCcq}/></TabItem>
            </FormListBaseTab>
        </FormListBase>
    );
}
